const Identifier = {
  print: ({ node }) => node.name
};

module.exports = Identifier;
